<template>
  <b-col>
    <template v-if="!hideName">
      <b>{{name || 'Languages'}}</b><br>
    </template>
    <template v-if="Array.isArray(value) && value.length > 0">
      <div>
        <span
          class="skill-tag mr-1 mt-1"
          :style="{ backgroundColor: backgroundColor || '#eee' }"
          v-for="languageKey in value"
          :key="languageKey"
        >{{getLanuageName(languageKey)}}</span>
      </div>
    </template>
    <template v-else>
      <span class="text-muted">{{ value }}</span>
    </template>
  </b-col>
</template>

<script>
import ISO6391 from 'iso-639-1';

export default {
  name: 'JobLanguagesShow',
  props: {
    name: {
      type: String,
    },
    value: {
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: '#eee',
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getLanuageName: key => ISO6391.getName(key),
  }
};
</script>

<style lang="scss" scoped>
.skill-tag {
  display: inline-block;
  font-size: 13px;
  padding: 3px 6px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/LanguagesShow.vue